const STATUS_MAP = {
  approved: "aprovado",
  paid: "aprovado",
  pago: "aprovado",
  succeeded: "aprovado",
  success: "aprovado",
  pendente: "pendente",
  pending: "pendente",
  processing: "pendente",
  in_process: "pendente",
  falhou: "falhou",
  failed: "falhou",
  failure: "falhou",
  rejected: "falhou",
  cancelled: "cancelado",
  canceled: "cancelado",
  cancelado: "cancelado",
  refunded: "estornado",
  charged_back: "estornado",
};

export function normalizePaymentStatus(rawStatus) {
  const key = String(rawStatus || "pendente").trim().toLowerCase();
  return STATUS_MAP[key] || "pendente";
}
